import carinaDarkFormula from "./carinaDarkFormula";
export { carinaDarkFormula };
export default carinaDarkFormula;
